const CONSENT_KEY = "ckris_cookie_consent";

function hasConsent() {
  return localStorage.getItem(CONSENT_KEY) === "accepted";
}

export function track(event = "pageview", extra = {}) {
  if (!hasConsent()) return;

  const payload = {
    event,
    page: window.location.pathname,
    referrer: document.referrer || null,
    screen_width: window.screen.width,
    ...extra,
  };

  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
    navigator.sendBeacon("/api/track", blob);
    return;
  }

  fetch("/api/track", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
